import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="profile-card">
          <div className="image-wrapper">
            <img src="https://profilepictureabhilashdurgam.s3.eu-west-1.amazonaws.com/Abhilosh+Durgom-1+(1).jpg" alt="Avatar" />
          </div>
          <div className="content">
            <div className="social_icons">
              <a href="https://github.com/sowthewind-reapthewhirlwind" target="_blank" rel="noreferrer"><GitHubIcon /></a>
              <a href="https://www.linkedin.com/in/abhilash-durgam-095321156/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            </div>
            <h1>Abhilash Durgam</h1>
            <p>Engineer II; Robotics - Vision - Deep Learning </p>

            <div className="mobile_social_icons">
              <a href="https://github.com/sowthewind-reapthewhirlwind" target="_blank" rel="noreferrer"><GitHubIcon /></a>
              <a href="https://www.linkedin.com/in/abhilash-durgam-095321156/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
}

export default Main;